import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CustomerService } from '../../../../features/customers/services/customer.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-address',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './address.component.html',
  styleUrl: '../../client-new.component.scss',
})
export class AddressComponent {
  billingAddressForm: FormGroup;
  shippingAddressForm: FormGroup;
  @Input() customerData: any = {};
  @Output() formSubmit = new EventEmitter<any>();
  search: string | undefined;
  filter: {};
  currencyData: any;
  file: any;
  customerId: any;
  countries: any[] = [];
  private billingSubscription?: Subscription;
  isCopyBillingChecked = false;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.initForm();
    this.route.paramMap.subscribe((params) => {
      this.customerId = params.get('id');
      if (this.customerId) {
        this.fetchCustomerById();
      }
    });
    this.loadCountries();
  }

  initForm() {
    this.billingAddressForm = this.fb.group({
      address: ['', Validators.required],
      city: [''],
      state: [''],
      country: [''],
      pinCode: ['', [Validators.maxLength(8), Validators.pattern(/^\d+$/)]],
    });
  }

  fetchCustomerById() {
    this.customerService.fetchCustomerById(Number(this.customerId)).subscribe({
      next: (data) => {
        this.customerData = data;
        this.populateFormWithCustomerData();
      },
      error: (error) => {
        console.error(error, 'Error');
      },
    });
  }

  populateFormWithCustomerData() {
    if (this.customerData) {
      this.billingAddressForm.patchValue({
        address: this.customerData.address || '',
        city: this.customerData.city || '',
        state: this.customerData.state || '',
        country: this.customerData.country || '',
        pinCode: this.customerData.zipCode || '',
      });
    }
  }

  loadCountries(): void {
    this.http.get<any[]>('assets/json/countries.json').subscribe(
      (data) => {
        this.countries = data;
      },
      (error) => {
        console.log('Error loading country data----', error);
      }
    );
  }

  onCancel() {
    this.billingAddressForm.reset();
    this.shippingAddressForm.reset();
  }

  onSubmitBilling(): boolean {
    if (this.billingAddressForm.invalid) {
      this.billingAddressForm.markAllAsTouched();
      this.toastr.error(
        'Please fill out the required address form',
        'Validation Error'
      );
      return false;
    }

    const {
      address,
      city,
      state,
      country,
      pinCode: zipCode,
    } = this.billingAddressForm.value;

    this.formSubmit.emit({ address, city, state, country, zipCode });
    return true;
  }

  ngOnDestroy() {
    // Clean up subscription on component destroy
    if (this.billingSubscription) {
      this.billingSubscription.unsubscribe();
    }
  }
}
